import { Fragment } from 'react'

import { renderCell } from './EmailReconnectTableRow.utils'

import * as styles from './EmailReconnectTableRow.module.css'

function EmailReconnectTableRow({ columns, item, onClickButton }) {
  return (
    <div className={styles.row} key={item.id}>
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderCell({
            item,
            name: column.name,
            width: column.width,
            onClick: onClickButton,
          })}
        </Fragment>
      ))}
    </div>
  )
}

export default EmailReconnectTableRow
